export var FlagDataType;
(function (FlagDataType) {
    FlagDataType["s"] = "string";
    FlagDataType["b"] = "boolean";
    FlagDataType["i"] = "number";
})(FlagDataType || (FlagDataType = {}));
